import { render, staticRenderFns } from "./oprate.vue?vue&type=template&id=cb004b7a&scoped=true&"
import script from "./oprate.vue?vue&type=script&lang=js&"
export * from "./oprate.vue?vue&type=script&lang=js&"
import style0 from "./oprate.vue?vue&type=style&index=0&id=cb004b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb004b7a",
  null
  
)

export default component.exports